import { forbesMockBalance } from 'api/forbesMock/forbesMockBalanceSSService';

export const forbesMockGetUserBalance = () => Promise.resolve(forbesMockBalance.get());
